import { useNavigate } from 'react-router-dom';
import { WeatherPanel } from './WeatherPanel';
import { useWeatherPlace } from './useWeatherPlace';

/**
 * 대시보드 맨 위 **고정 줄** (2026-09-21 · 시안 v3·v4 확정 — 사용자 결정 ⓑ).
 *
 * ★★★ **위젯이 아니다.** 담고 빼는 설정이 없고, 편집 모드에서 끌거나 지울 수 없다 —
 *      보드를 바꿔도 같은 자리에 선다(화면의 «머리»다).
 * ★★ 날씨 **위젯을 담은 보드에서는 이 줄이 빠진다**(부르는 쪽이 판단한다) — 같은 값이 한 화면에
 *     둘이면 사람들은 「하나가 틀렸다」로 읽는다. 위젯을 빼면 줄이 다시 돌아온다.
 * ★ 기준은 **내 사업장, 없으면 회사**(서버가 정한다). 고정 줄에는 설정이 없으므로 기본값만 쓴다.
 */
export function WeatherStrip() {
  const navigate = useNavigate();
  const { state, reload, canEditAddress } = useWeatherPlace();

  return (
    <WeatherPanel
      variant="strip"
      state={state}
      canEditAddress={canEditAddress}
      onOpenCompany={() => navigate('/settings')}
      onRetry={reload}
    />
  );
}
